module.exports = __webpack_public_path__ + "24a11fa4b1debb45dab9a997f26ae075.png";